const ShowMore = ({ currentPage, setCurrentPage, totalPages, isLoading }) => {
    const handleClick = () => {
        setCurrentPage(currentPage + 1);
    };

    if (currentPage >= totalPages) {
        return '';
    }

    return (
        <div className="vehiclesearch-showmore" data-aos="fade-up">
            <button className="button button--primary" onClick={handleClick}>{isLoading ? 'Laddar...' : 'Visa fler'}</button>
        </div>
    );
}

export default ShowMore
